/**
 * AnalyticsService
 * @module Services/utils/AnalyticsService
 * @description Offers utility functions to handle strings
 */
import _ from 'lodash';

const self = {};

const LOCAL_STORAGE_GA_TAG = 'analytics_active';
const ANALYTICS_CONSENT_EVENT_NAME = 'analyticsConsentChanged';

const dispatchConsentChanged = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const consentEvent = new Event(ANALYTICS_CONSENT_EVENT_NAME);
  window.dispatchEvent(consentEvent);
};
/**
 * TODO
 * @author Hassen Charef
 * @alias getInitials
 * @memberof module:Services/utils/AnalyticsService
 */
self.enableAnalyticsCookie = () => {
  localStorage.setItem(LOCAL_STORAGE_GA_TAG, "enable");
  dispatchConsentChanged();
};

self.isAnalyticsActive = () => {
  const res = (localStorage.getItem(LOCAL_STORAGE_GA_TAG) === "enable");
  return res;
};

self.isGTMActive = () => {
  return self.isAnalyticsActive();
};

self.disableAnalyticsCookie = () => {
  localStorage.setItem(LOCAL_STORAGE_GA_TAG, "disable");
  dispatchConsentChanged();
};

self.ANALYTICS_CONSENT_EVENT_NAME = ANALYTICS_CONSENT_EVENT_NAME;

export default self;
